'use strict';
import init from "./main";
import NewItem from "./widgets/newItem";
import uploadHandler from "./widgets/uploadHandler";
import {empty} from "./utils/makeElement";
import {notify, notifyPersistent} from "./events/notify";
import {login} from "./utils/login";
import {listenLogin, isAllowed} from "./events/login";

init().then(function(app){
  const uploadBucketRef = app.storage(app.options.uploadBucket).ref();
  listenLogin(function(e){
    const user = e.detail;
    const scope = window.clientScope;
    if(!user){
      return login();
    }
    if(!user.claims){
      return console.log("Connected. Waiting for authorization...");
    }
    const parent = document.querySelector("DIV#upload-zone");
    const queue = document.createElement("div");
    queue.className = "uploads";
    empty(parent);
    if(!isAllowed(scope)){
      console.log(user);
      return notifyPersistent("error", "You are not allowed to upload here");
    }

    //This is where the magic happens.
    // It creates a reference to the target file and delegates it to uploadHandler
    // uploadHandler wraps the task's progress in an HTMLElement
    function handleUploadStart(file, name, meta){
      console.log(`Uploading ${file.name} (format: ${meta.format}) for ${user.uid} as ${name}`)
      let destRef = uploadBucketRef.child(`/upload/${user.uid}/${name}`);
      queue.appendChild(uploadHandler(file, destRef, meta));
    }

    var newItem = new NewItem(handleUploadStart, window.clientScope);
    parent.appendChild(queue);
    parent.appendChild(newItem.element);
  });
})
